<template>
  <div>
    <div id="page-wrapper" :class="['main-app-page-wrapper', 'main-app-bg', {'app-developer-mode': !appIsLiveSite && !appIsLocalSite, 'app-developer-local-mode': appIsLocalSite, 'app-user-proxy-access': userHasProxyAccess}]">
      <TopNavBar @displaySynergyAI="displaySynergyAI" />
      <div :class="{'page-error': true, 'alert': true, 'alert-warning': !pageErrorInfo.isError, 'alert-danger': pageErrorInfo.isError}" v-if="pageErrorInfo">
        <i class="fas fa-exclamation-triangle"></i> {{pageErrorInfo.message}}
        <a class="float-right" href="#" @click.prevent="reloadPage" v-if="pageErrorInfo.retryAvailable">Try Again</a>
      </div>
      <div v-if="appVersionUpdatedRequired" class="app-minversion-warning">
        <i class="fa-shake fas fa-exclamation-triangle text-danger mr-2" /> A new version of the Synergy system is available. Please <a href="javascript:window.location.reload();">refresh</a> to update your browsers version of the app
      </div>

      <div class="row" v-if="title != null && !hideBreadcrumbs">
        <div class="col-lg-9" style="padding-left: 25px;">
          <ol class="inner-breadcrumb">
            <li
              class="breadcrumb-item"
              v-for="(crumb, index) in breadcrumbs"
              v-bind:key="index"
              :class="[ index == breadcrumbs.length-1 ? 'active' : '' ]"
            >
              <router-link v-if="index < breadcrumbs.length-1" :to="crumb.link">{{crumb.title}}</router-link>
              <strong v-if="index == breadcrumbs.length-1">{{crumb.title}}</strong>
            </li>
          </ol>
        </div>
      </div>

      <div class="wrapper wrapper-content">
        <div class="row">
          <div class="col-lg-12">
            <slot/>
          </div>
        </div>
      </div>

      <div class="system-footer-info">
        <span v-html="appCopyrightInfo" /> - {{appVersion}}
        <span v-if="!appIsLiveSite"> - DEVELOPMENT VERSION</span>
      </div>

      <SynergyAISidebar v-if="synergyAIEnabled" @close="synergyAIEnabled = false"></SynergyAISidebar>
    </div>
  </div>
</template>

<style lang="scss">
$page-header-bar-height: 60px;
$page-header-bar-option-height: 40px;

.main-app-page-wrapper {
  padding: 0 15px;
  position: relative !important;
  margin: 0 !important;
}
.main-app-systeminfo {
  position: absolute;
  left: 4px;
  bottom: 2px;
  color: #A7B1C2;
  font-size: 10px;
}
.page-header-bar {
  height: $page-header-bar-height;
  padding-left: 16px;
  padding-right: 32px;
  white-space: nowrap;
  flex-wrap: nowrap;
}
.page-header-bar ul {
  flex-wrap: nowrap;
}

.page-navbar-group {
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.page-navbar-item {
  flex: 1;
}
.glass-nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.glass-nav.glass-navbar-mainmenu {
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  flex: 1;
  
}
.glass-navbar-top-links {
  white-space: nowrap;
}
.glass-navbar-top-links > li {
  display: inline-block;
  align-self: center;
  white-space: nowrap;
}
.wrapper-content {
  padding: 15px 10px 5px 10px;
}

.glass-navbar-top-links li:last-child {
  margin-right: 0px;
}

.glass-navbar-option > a.glass-navbar-top-notification {
  margin-right: 15px;
}
.glass-notification-icon {
  font-size: 1.5rem;
  line-height: 1.5rem;
  vertical-align: middle;
  color: #b7b7b7;
}
.glass-notification-icon.active {
  color: #b7b7b7;
}
.glass-notification-icon.animate {
  animation-name: notification-bell-shake;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
  animation-iteration-count: 2;
  animation-delay: .5s;
}
@keyframes notification-bell-shake {
  0%,
  100% {
    transform: rotate(0deg);
  }
  20%,
  60% {
    transform: rotate(8deg);
  }
  40%,
  80% {
    transform: rotate(-8deg);
  }
}

.glass-notification-badge {
  position: absolute;
  background-color: #ED5565;
  display: inline-block;
  color: #fff;
  right: 0.0rem;
  top: 0.0rem;
  font-size: .6rem;
  min-width: 1rem;
  max-width: 1.6875rem;
  padding: 0 3px;
  border-radius: 1.25rem;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: middle;
}

.glass-navbar-option {
  text-align: center;
}
.glass-navbar-option > a {
  color: #b7b7b7;
  display: inline-block;
  position: relative;
  font-size: 15px;
  margin-right: 2px;
  padding-left: 6px;
  padding-right: 6px;
  width: $page-header-bar-option-height;
  height: $page-header-bar-option-height;
  line-height: $page-header-bar-option-height;
  vertical-align: middle;
}
.glass-navbar-option > a:hover {
  background-color: #303030;
  color: #f0f0f0;
  border-radius: 10px;
}
.glass-navbar-option > a > .unread-notification {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  top: 6px;
  right: 6px;
  background-color: #ED5565;
}

.glass-navbar-option.synergy-navbar-ai > a {
  width: 120px;
  color: #FFFFFF;
}
.glass-navbar-option.synergy-navbar-ai > a > i {
  font-size: 18px;
  background-clip: text !important;
  color: #83e09c;
}

.navbar-profile-column {
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.navbar-profile-inner {
  display: flex;
  flex-direction: row-reverse;
  margin: auto 0 auto 0
}
.navbar-profile-name-cell {
  display: inline-block;
  vertical-align: top
}
.navbar-profile-name {
  font-size: 12px;
  font-weight: normal;
  color: #a0a0a0;
  padding: 0px 0px 0px 0px;
  vertical-align: middle;
  line-height: 43px
}
.inner-breadcrumb {
  padding: 15px 0 0 0;
  margin-bottom: 0px;

  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none;
  border-radius: 0;
}
.glass-navbar-avatar-container {
  position: relative;
}
.glass-navbar-avatar-warning {
  position: absolute;
  top: -5px;
  left: -10px;
  width: 20px;
  height: 20px;
  padding: 2px 0px 0px 0px;
  border-radius: 50%;
  background-color: #ed5565;
  color: #ffffff;
  text-align: center;
}
.inner-breadcrumb > li a {
  color: inherit;
}

.page-title {
  margin-top: 0px;
  margin-bottom: 10px;
}
.page-system-footer {
  color: #b7b7b7;
  text-shadow: 0px 1px 1px #f7f7f7;

  bottom: 0;
  left: 0;
  padding: 10px 20px;
  position: absolute;
  right: 0;
}
.theme-dark .page-system-footer {
  color: #777777;
  text-shadow:none;
}

.page-error {
  position: absolute;
  left: 50%;
  top: calc(#{$page-header-bar-height} + 5px);
  width: 500px;
  margin-left: -250px;
  padding: 0.6rem;
  font-size: 0.75rem;
  z-index: 10000;
}
.page-error > a:hover {
  text-decoration: underline;
}

.system-footer-info {
  padding-top: 6px;
  padding-bottom: 4px;
  font-size: 11px;
  text-align: center;
  color: #b0b0b0;
}
</style>

<script>
import Avatar from '@/components/avatar'
import themeMixin from '@/mixins/theme'
import NavbarSystemSearch from '@/components/page/navbarSystemSearch.vue'
import UserChangePasswordDialog from '@/modules/users/views/userChangePasswordDialog.vue'
import EditLogoImageDialog from '@/modules/core/views/editLogoImageDialog.vue'
import TopNavBar from '@/components/page/topNavBar'
import NavbarMenuItem from '@/components/page/navbarMenuItem'

import SynergyAISidebar from '@/modules/intelligence/components/synergyAISidebar'

import { mapState } from "vuex"

export default {
  name: "DefaultLayout",
  mixins: [themeMixin],
  components: {
    Avatar,
    TopNavBar,
    NavbarSystemSearch,
    NavbarMenuItem,
    SynergyAISidebar
  },
  data() {
    return {
      shakeNotificationBell: false,
      synergyAIEnabled: false
    }
  },
  computed: {
    ...mapState({
      profileName: state => state.profile.profileUser.name,
      menu: state => state.profile.menuList,
      profileLogoURL: state => state.profile.profileUser.logoURL,
      notificationUnreadCount: state => state.profile.notifications.unreadCount,
      isChangeLogUpdated: state => state.profile.changeLogUpdatedAlert,
      pageErrorInfo: state => state.page.pageError,
      isAccountInitialBillingSetup: state => state.account.isAccountInitialBillingSetup,
      isAccountActivated: state => state.account.isAccountActivated,
      isSubscriptionExpired: state => state.account.isSubscriptionExpired,
      isSubscriptionExpiringSoon: state => state.account.isSubscriptionExpiringSoon,
      appVersionUpdatedRequired: state => state.system.appVersionUpdatedRequired
    }),
    title() {
      return this.$route.meta.title || ''
    },
    hideBreadcrumbs() {
      return this.$route.meta.hideBreadcrumbs || false
    },
    breadcrumbs() {
      var breadcrumbs = this.$route.meta.breadcrumbs || []
      if(this.$store.state.page.breadcrumbList.length > 0)
        breadcrumbs = this.$store.state.page.breadcrumbList
      
      var pageTitle = this.$store.state.page.pageTitle
      if(pageTitle)
        return breadcrumbs.concat([{title: pageTitle, link: ''}])

      return breadcrumbs
    },
    appCopyrightInfo() {
      return this.$store.state.system.appCopyrightInfo
    },
    appVersion() {
      return this.$store.state.system.appVersion
    },
    appIsLiveSite() {
      return this.$glass.isLiveSite
    },
    appIsLocalSite() {
      return this.$glass.isLocalSite
    },
    userHasProxyAccess() {
      return this.$store.state.system.appUserProxyAccess
    },
    displaySubscriptionExpiryWarning() {
      // Only display 'expiry soon' warnings for subscriptions if the user has ability to view account info
      return !this.isSubscriptionExpired && this.isSubscriptionExpiringSoon && this.userHasReadPermission(this.PermissionTypes.AdminPermissionTypes.account)
    },
    profileAvatarImage() {
      if (this.profileLogoURL && this.profileLogoURL != '')
        return this.profileLogoURL
      return '/glass/img/user-overview-male.png'
    },
    canUpdateTheme() {
      // Only available on local testing for now
      return this.appIsLocalSite
    }
  },
  watch: {
    notificationUnreadCount: function(newVal, oldVal) {
      if(this.notificationUnreadCount > 0 && (newVal > oldVal || oldVal === undefined)) {
        this.shakeNotificationBell = true

        // Remove after a few seconds
        setTimeout(() => { this.shakeNotificationBell = false }, 5000)
      }
    }
  },
  mounted() {
    this.loadLocalSettings()
  },
  methods: {
    loadLocalSettings() {
      let storedTheme = localStorage.getItem('profile-theme-class')
      if(storedTheme)
        this.setThemeClass(storedTheme)
    },
    logout(event) {
      this.$authService.clearAuthSession();
      this.$store.commit("profile/clearProfile")
      this.$store.commit("account/clearAccountData")
      this.$router.push("/login");
    },

    requestProfileData() {
      // Refresh the profile
      this.$api.get("/profile").then(response => {
        this.$store.commit("profile/setProfile", response.data);
      })
      this.$apiService.adminService.getAccount().then(response => {
        this.$store.commit("account/setAccountData", response.data)
      })
    },

    profileChangePassword() {
      this.displayModal(UserChangePasswordDialog)
      .then((success) => {
        if(success) {
          this.successToast('Password Updated')
          this.requestData()
        }
      })
    },

    profileUpdateImage() {
      this.displayModal(EditLogoImageDialog, { 
        resourceId: 'current',
        APIresource: 'users',
        currentURL: this.profileLogoURL,
        circleCrop: true
      })
      .then((success) => {
        if(success) {
          this.successToast('Logo Updated')
          this.requestProfileData()
        }
      })
    },

    profileRemoveImage() {
      this.confirmDeleteMessage('Remove Profile Image?', 'Are you sure you remove your profile image?')
      .then(success => {
        if(success) {
          this.$apiService.coreService.deleteLogoImage('current', 'users').then(response => {
            this.successToast('Image Removed')
            this.requestProfileData()
          })
        }
      })
    },

    displayNotifications(evt) {
      this.$router.push("/communication/notifications");
    },
    displayAddNewPopover(evt) {
      this.$refs.addNewPopover.displayFromElement(evt.target)
    },
    viewWhatsNew() {
      this.$router.push("/help/whatsnew");
    },

    reloadPage() {
      this.$router.go(0)
    },

    viewUserProfile() {
      this.$router.push('/users/profile')
    },
    setLocalTheme(themeClass) {
      localStorage.setItem('profile-theme-class', themeClass)
      this.setThemeClass(themeClass)
    },

    displayAccount() {
      if(this.userHasReadPermission(this.PermissionTypes.AdminPermissionTypes.account)) {
        this.$router.push('/admin/account')
      }
    },

    displaySynergyAI() {
      this.$router.push('/ai')
    }
  }
};
</script>